import { Container, styled, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button, { buttonClasses } from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import { Auth } from './Auth';
import { Breadcrumbs } from './Breadcrumbs';
export function AppHeader(props) {
    const { menuItems, breadcrumbs, maxWidth, disableGutters, dense } = props;
    return React.createElement(React.Fragment, null,
        React.createElement(StyledAppBar, { position: "sticky", elevation: 0 },
            React.createElement(Container, { maxWidth: maxWidth, disableGutters: disableGutters },
                React.createElement(StyledToolbar, { disableGutters: true, variant: dense ? 'dense' : 'regular' },
                    React.createElement(Logo, null),
                    React.createElement(Nav, null, menuItems.map(({ label, href }, i) => React.createElement(Button, { key: i, href: href }, label))),
                    React.createElement(Auth, null)))),
        breadcrumbs != null &&
            React.createElement(BreadcrumbsContainer, null,
                React.createElement(Container, { maxWidth: maxWidth, disableGutters: disableGutters },
                    React.createElement(Breadcrumbs, { dense: dense }, breadcrumbs.map(({ label, href }, i) => React.createElement(Link, { key: i, href: href }, label))))));
}
const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);
const StyledAppBar = styled(AppBar, { slot: 'Root' })(({ theme }) => ({
    backgroundColor: theme.palette.ui.appheader.main
}));
const BreadcrumbsContainer = styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
}));
const StyledToolbar = styled(Toolbar, { slot: 'Root' })(({ theme }) => ({}));
const Nav = styled(Stack, { slot: 'Root' })(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    [`& .${buttonClasses.root}`]: {
        color: theme.palette.common.white
    }
}));
function Logo() {
    return React.createElement(Link, { href: "/", sx: { color: 'inherit', textDecoration: 'none' } },
        React.createElement(Typography, { variant: "body1", sx: { fontWeight: 900 }, component: "span" }, "Dobolj!"));
}
//# sourceMappingURL=AppHeader.js.map